import * as core from '../../../../../../../core'

import { query } from './explore-metrics-no-idc-funding.query'

export const RESOURCE = {
  payload: {
    alias: 'rp.explore.widgets.metrics-report-card',
    description:
      'Version of the Metrics widget that accounts for Institution, Organization, and PI Lenses without Award Funding, IDC, or related metrics',
    name: 'RP Explore - Metrics',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
